import type { FC } from "react";
import { useNavigate } from "react-router";

import type { SiteVirtualSiteGroupEntity } from "src/app/features/Site/types/SiteVirtualSiteGroupEntity";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";
import type { ExtendedColumnsType } from "../../../index";
import { PropertyTable } from "../../../Table/components/PropertyTable";
import { displayDateTimeValue } from "../../../Table/components/PropertyTable/transformations/cellTransformations";
import type { AntCustomFormField, CommonFieldAttributes } from "../../types/types";

const getColumnsConfig = (t: Function): ExtendedColumnsType<SiteVirtualSiteGroupEntity>[] => {
    return [
        {
            title: t("list.form.id"),
            key: "id",
            dataIndex: "id",
        },
        {
            title: t("list.form.name"),
            key: "name",
            dataIndex: "name",
        },
        {
            title: t("form.virtualSiteGroup.priority"),
            key: "priority",
            dataIndex: "priority",
        },
        {
            title: t("site.column.changed"),
            key: "changed",
            dataIndex: "changed",
            render: (value) => displayDateTimeValue(value),
        },
    ];
};

export interface VirtualSitesTableProps extends AntCustomFormField<SiteVirtualSiteGroupEntity[]>, CommonFieldAttributes {}

export const SitesVirtualSitesTable: FC<VirtualSitesTableProps> = ({ value = [], readOnly }) => {
    const navigate = useNavigate();

    const onRowClick = (record: SiteVirtualSiteGroupEntity) => {
        navigate(`${BASE_PATH}/${ResourceName.VIRTUAL_SITE_GROUPS}/${FORM_ACTION.EDIT}/${record.id}`);
    };

    return (
        <PropertyTable<SiteVirtualSiteGroupEntity>
            name="virtual_sites_table"
            getColumnsConfig={getColumnsConfig}
            propertyAsRowKey="id"
            tableData={value}
            readOnly={readOnly || false}
            rowsAreSelectable={false}
            onRow={(record: SiteVirtualSiteGroupEntity) => {
                return {
                    onClick: () => onRowClick(record),
                };
            }}
        />
    );
};
